import script from "./AnnotationHistoryViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnotationHistoryViewer.vue?vue&type=script&setup=true&lang=ts"

import "./AnnotationHistoryViewer.vue?vue&type=style&index=0&id=42fae441&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42fae441"]])

export default __exports__